export default __webpack_public_path__ + "static/media/link_upload_icon.55e11c79.svg";